import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';

const DataModal = ({ 
  isOpen, 
  toggle, 
  title = "Información",
  data = [],
}) => {
  const renderDataRow = (item, index) => {
    const isEven = index % 2 === 0;
    const backgroundColor = isEven ? 'white' : '#f8f9fa';
    
    const renderValue = () => {
      if (item.type === 'email') {
        return (
          <a 
            href={`mailto:${item.value}`}
            style={{ 
              color: '#007bff', 
              textDecoration: 'none' 
            }}
          >
            {item.value}
          </a>
        );
      } else if (item.type === 'phone') {
        return (
          <a 
            href={`tel:${item.value}`}
            style={{ 
              color: '#007bff', 
              textDecoration: 'none' 
            }}
          >
            {item.value}
          </a>
        );
      } else {
        return <span>{item.value}</span>;
      }
    };

    return (
      <div 
        key={index}
        style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          padding: '15px 20px',
          backgroundColor: backgroundColor,
          borderBottom: index < data.length - 1 ? '1px solid #dee2e6' : 'none'
        }}
      >
        <span style={{ fontWeight: '500' }}>{item.label}</span>
        {renderValue()}
      </div>
    );
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="cobranza-modal">
      <ModalHeader 
        className="bg-155892"
      >
        <label className="header-label font-weight-bold m-0">{title}</label>
        <button type="button" className="close" aria-label="Close" onClick={toggle}>
            <span aria-hidden="true">×</span>
        </button>
      </ModalHeader>
      <ModalBody style={{ padding: 0 }}>
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column',
          border: '1px solid #dee2e6'
        }}>
          {data.map((item, index) => renderDataRow(item, index))}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DataModal;

